export const dictionary = {
  MARK_READ: {
    ES: "Marcar todas como leídas",
    EN: "Mark all as read",
  },
  NEW_NOTIFICATION: {
    ES: "Tienes nuevas notificaciones.",
    EN: "You have new notifications.",
  },
  NEW_ORDER: {
    ES: "Nuevo pedido",
    EN: "New order",
  },
  READ: {
    ES: "Leído",
    EN: "Read",
  },

  UNREAD: {
    ES: "No leído",
    EN: "Unread",
  },
  NO_NOTIFICATIONS: {
    ES: "No tienes nuevas notificaciones",
    EN: "No new notifications",
  },
} as const;
